import React from 'react';
import { createContext } from 'use-context-selector';
import { useAuth } from '@auth-wrapper';
import { makeSimulation as makeSimulationAPI } from '@services/scenarios-simulator';
import { notifyError } from '@components/atoms/toast/services';
import { ISimulationPayload } from '@schemas/scenarios-simulator/types';

interface MakeSimulationContextData {
  isLoadingMakeSimulation: boolean;
  makeSimulation: (simulationPayload: ISimulationPayload) => Promise<any>;
  simulation: ISimulationPayload;
}

export const MakeSimulationContext = createContext({} as MakeSimulationContextData);

interface Provider {
  children: React.ReactNode;
}

const MakeSimulationProvider: React.FC<Provider> = ({ children }) => {
  const {
    authStatus: { accessToken: token },
  } = useAuth();

  const [simulation, setSimulation] = React.useState<ISimulationPayload>({});
  const [isLoadingMakeSimulation, setIsLoadingMakeSimulation] = React.useState<boolean>(false);

  const makeSimulation = React.useCallback(
    async (simulationPayload: ISimulationPayload): Promise<any> => {
      if (!token) {
        notifyError('No authentication token available');
        return;
      }

      setIsLoadingMakeSimulation(true);
      try {
        const result = await makeSimulationAPI(simulationPayload, token);
        setSimulation(result);
        return result;
      } finally {
        setIsLoadingMakeSimulation(false);
      }
    },
    [token],
  );

  return (
    <MakeSimulationContext.Provider
      value={{
        makeSimulation,
        isLoadingMakeSimulation,
        simulation,
      }}
    >
      {children}
    </MakeSimulationContext.Provider>
  );
};

export default MakeSimulationProvider;
